import React from 'react';
import ReactDOM from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import enMessages from './i18n/messages/en.json';
import { ScopeProvider } from './scopeContext';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <IntlProvider locale="en" messages={enMessages as Record<string, string>}>
      <BrowserRouter>
        <ScopeProvider>
          <App />
        </ScopeProvider>
      </BrowserRouter>
    </IntlProvider>
  </React.StrictMode>
);
